import { request } from '@/utils/request'
const IndexService = {
  state: {},

  mutations: {},

  actions: {
    // 获取今日用电，昨日用电
    GetPowerProjectInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/chengwu/v2/GetPowerProjectInfo', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // （本月每天，上月每天）月度用电量
    GetQiYeZongYongDianLiang({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/chengwu/v2/GetQiYeZongYongDianLiang', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 今日昨日24小时的用电数据
    GetPropertyData({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/chengwu/v2/GetPropertyData', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 分区能耗统计
    GetNengHaoTongJiForFenQv({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/chengwu/v2/GetNengHaoTongJiForFenQv', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 温度湿度折线图数据
    GetQvXian_By_EquipmentIDstr_DoubleLine({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/GetQvXian_By_EquipmentIDstr_DoubleLine', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 分项能耗统计
    GetNengHaoTongJiForFenXiang({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/chengwu/v2/GetNengHaoTongJiForFenXiang', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 健康度
    GetJKDEquipmentInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/GetJKDEquipmentInfo', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 同比环比
    GetYongDianLiang_More({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/GetYongDianLiang_More', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default IndexService
